import "./pitch.css";

export const HOURS_CIRCLES = {
  outer: "The team sees who is on",
  middle: "The planner sees the team",
  inner: "Only the member sees their own notes and reasons",
  caption: "Three circles of privacy",
};

export interface HoursCirclesProps {
  copy?: typeof HOURS_CIRCLES;
}

/** `hours.html`: the three privacy circles, nested. */
export function HoursCircles({ copy = HOURS_CIRCLES }: HoursCirclesProps) {
  return (
    <figure className="pitch pitch-circles-wrap" style={{ margin: 0 }}>
      <div className="pitch-circle pitch-circle-3">
        <span>{copy.outer}</span>
        <div className="pitch-circle pitch-circle-2">
          <span>{copy.middle}</span>
          <div className="pitch-circle pitch-circle-1">
            <span>{copy.inner}</span>
          </div>
        </div>
      </div>
      <figcaption className="pitch-text">{copy.caption}</figcaption>
    </figure>
  );
}
